import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

const HaulerDetailsConfig = { auth: [...authRoles.admin, ...authRoles.hauling], routes: [{ path: '/hauler-management/:id?', component: FuseLoadable({ loader: () => import('./hauler-details/HaulerDetails') }) }] };

export default HaulerDetailsConfig;
